<template>
  <form class="custom-options">
    <div v-for="option in product.custom_options" :key="('customOption_' + option.option_id)">
      <div class="custom-option mb15 align-left" v-if="option.values.length && option.is_active === 1">
        <h4>{{ option.title }}</h4>
        <input
          class="py10 w-100 border-box brdr-none brdr-bottom-1brdr-cl-primary h4 sans-serif"
          v-if="option.type === 'field'"
          type="text"
          :name="('customOption_' + option.option_id)"
          focus
          v-model="inputValues[('customOption_' + option.option_id)]"
          :placeholder="option.title"
          @change="optionChanged(option)"
        >
        <!-- RADIO -->
        <div class="m5 relative" v-for="opval in option.values" :key="opval.option_type_id" v-if="option.type === 'radio'">
          <input
            @change="radioOption(option, opval)"
            type="radio"
            class="m0 no-outline radio"
            :name="('customOption_' + option.option_id)"
            :id="('customOption_' + opval.option_type_id)"
            focus
            :value="opval.option_type_id"
            v-model="inputValues[('customOption_' + option.option_id)]"
            v-if="opval.is_active === 1"
          >
          <label class="pl10 lh20 h4 pointer radio-label checkbox-option" :for="('customOption_' + opval.option_type_id)" v-html="opval.title" />
          <span class="price bold">{{opval.price}} <span class="">грн</span> </span>
        </div>
        <!-- SELECT or DROP DOWN -->
        <div class="m5 relative" v-if="(option.type === 'select' || option.type === 'drop_down') && option.values && option.values.length">
          <div class="select-wrapper relative">
            <select :name="('customOption_' + option.option_id)" @change="selectOption(option, 'find', $event.target.value)">
              <option v-for="opval in option.values"
                      :key="opval.option_type_id"
                      :value="opval.option_type_id"
                      v-bind="{selected: opval.option_type_id === inputValues[('customOption_' + option.option_id)]}"
                      v-if="opval.is_active === 1"
              >
                {{ opval.title }} (<span class="price bold"> +{{opval.price}} <span>грн</span></span>)
              </option>
            </select>
          </div>
        </div>
        <!-- CHECKBOX -->
        <div class="m5 relative block-option flex" v-for="opval in option.values" :key="opval.option_type_id" v-if="option.type === 'checkbox' && opval.is_active === 1">
          <template v-if="option.values.length > 1">
            <product-qty-option :option="opval" :rootOption="option" @addOption="addOption"/>
          </template>
          <template v-else>
            <span class="pl10 lh20 h4 checkbox-option">{{ opval.title }}</span>
            <span class="price end-md end-xs bold col-md-4 col-xs-4"> {{ opval.price }} <span>грн</span></span>
          </template>
        </div>
        <span class="error" v-if="validation.results[('customOption_' + option.option_id)].error">{{ validation.results[('customOption_' + option.option_id)].message }}</span>
      </div>
    </div>
  </form>
</template>

<script>
import { ProductCustomOptions } from '@vue-storefront/core/modules/catalog/components/ProductCustomOptions.ts'
import ProductQtyOption from "./ProductQtyOption";

export default {
  mixins: [ProductCustomOptions],
  components: {
    ProductQtyOption
  },
  created () {
    for (const option of this.product.custom_options) {
      const isSingleChoice = ['select', 'drop_down', 'radio'].includes(option.type);
      if (isSingleChoice && option.values && option.values.length) {
        this.$emit('changeCustomOptionsTotal', this.firstActiveValue(option), option.type === 'radio' ? 'radio' : 'select', option.option_id);
      }
    }
  },
  methods: {
    // picks the first is_active variant so the default selection matches what's actually rendered
    firstActiveValue (option) {
      return option.values.find(v => v.is_active === 1) || option.values[0]
    },
    selectOption (rootOption, option, value) {
      this.optionChanged(rootOption, option, value);

      const selectOption = rootOption.values.find(option => String(option.option_type_id) === value);
      this.$emit('changeCustomOptionsTotal', selectOption, 'select', rootOption.option_id);
    },
    radioOption (rootOption, option) {
      this.optionChanged(rootOption, option);
      this.$emit('changeCustomOptionsTotal', option, 'radio', rootOption.option_id);
    },
    addOption (rootOption, option, isDeleteOption) {
      this.optionChanged(rootOption, option, !isDeleteOption);
      this.$emit('changeCustomOptionsTotal', option, 'checkbox', rootOption.option_id);
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~theme/css/variables/colors';
  @import '~theme/css/helpers/functions/color';
  $color-tertiary: color(tertiary);
  $color-black: color(black);
  $color-hover: color(tertiary, $colors-background);

  $bg-secondary: color(secondary, $colors-background);
  $color-secondary: color(secondary);
  $color-error: color(error);

  .custom-option-number {
    text-align: center;
    border-style: solid;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.09px;
    color: #111111;
    border-width: 0 0 0 0;
    width: 40px;
    height: 1.4rem;
    outline: none;
    &::-webkit-outer-spin-button,&::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  .custom-option > label {
    font-weight: bold;
    margin-bottom: 10px;
  }

  .error {
    color: $color-error;
    padding-top: 5px;
    display: block;
  }
  $color-silver: color(silver);
  $color-active: color(secondary);
  $color-white: color(white);

  .relative label {
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 16px;
    line-height: 30px;
    word-break: break-word;
    &.radio-label{
      &:before {
        border-radius: 50%;
      }
    }
    &:before {
      content: '';
      position: absolute;
      top: 3px;
      left: 0;
      width: 22px;
      height: 22px;
      background-color: $color-white;
      border: 1px solid $color-silver;
      cursor: pointer;
    }
  }
  input[type='text'] {
    transition: 0.3s all;
    &::-webkit-input-placeholder {
      color: $color-tertiary;
    }
    &::-moz-placeholder {
      color: $color-tertiary;
    }
    &:hover,
    &:focus {
      outline: none;
      border-color: $color-black;
    }
    background: inherit;
  }
  input[type='radio'], input[type='checkbox']  {
    position: absolute;
    top: -2px;
    left: 4px;
    &:checked + label {
      &:before {
        background-color: $color-silver;
        border-color: $color-silver;
        cursor: pointer;
      }
      &:after {
        content: '';
        position: absolute;
        top: 9px;
        left: 5px;
        width: 11px;
        height: 5px;
        border: 3px solid $color-white;
        border-top: none;
        border-right: none;
        background-color: $color-silver;
        transform: rotate(-45deg);
      }
    }
    &:hover,
    &:focus {
      + label {
        &:before {
          border-color: $color-active;
        }
      }
    }
    &:disabled + label {
      cursor: not-allowed;
      &:hover,
      &:focus {
        &:before {
          border-color: $color-silver;
          cursor: not-allowed;
        }
      }
    }
  }
  .price{
    width: 17%;
    font-size: 16px;
    line-height: 30px;
  }
  .checkbox-option {
    width: 83%;
  }
  .select-wrapper {
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 1rem;
      right: 10px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 8px 6px 0 6px;
      border-color: $color-tertiary transparent transparent transparent;
      pointer-events: none;
    }

    select {
      border: none;
      color: #000;
      border-bottom: 1px solid $color-tertiary;
      width: 100%;
      -moz-appearance: none;
      -webkit-appearance: none;
      border-radius: 0;
      background-color: transparent;

      &:hover,
      &:focus {
        outline: none;
        border-color: #11bb2e;
      }

      &:disabled,
      &:disabled + label {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
      }
    }
    label {
      color: #999;
      position: absolute;
      pointer-events: none;
      user-select: none;
      top: 10px;
      left: 8px;
      transition: 0.2s ease all;
      -moz-transition: 0.2s ease all;
      -webkit-transition: 0.2s ease all;
    }
    select:focus ~ label, select:not(.empty) ~ label {
      top: -10px;
      font-size: 14px;
      color: #11bb2e;
    }
  }
  .block-option {
    align-items: center;
  }
</style>
